// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { GoalTemplate } from "../../types";

const goalTemplatesModule = {
  async findAll(): Promise<GoalTemplate[]> {
    try {
      const result = await sql`
        SELECT * FROM goal_templates
        ORDER BY is_system DESC, category, title
      `;
      return (result || []) as GoalTemplate[];
    } catch (error) {
      console.error('Error fetching goal templates:', error);
      return [];
    }
  },
  
  async findVisible(userId: string): Promise<GoalTemplate[]> {
    try {
      const result = await sql`
        SELECT gt.* FROM goal_templates gt
        WHERE (gt.is_system = true AND NOT EXISTS (
          SELECT 1 FROM user_hidden_templates uht 
          WHERE uht.user_id = ${userId} AND uht.goal_template_id = gt.id
        ))
        OR gt.user_id = ${userId}
        ORDER BY gt.is_system DESC, gt.category, gt.title
      `;
      return (result || []) as GoalTemplate[];
    } catch (error) {
      console.error('Error fetching visible goal templates:', error);
      return [];
    }
  },
  
  async findByUserId(userId: string): Promise<GoalTemplate[]> {
    try {
      const result = await sql`
        SELECT * FROM goal_templates
        WHERE user_id = ${userId}
        ORDER BY category, title
      `;
      return (result || []) as GoalTemplate[];
    } catch (error) {
      console.error('Error fetching user goal templates:', error);
      return [];
    }
  },
  
  async findById(id: string): Promise<GoalTemplate | null> {
    try {
      const result = await sql`
        SELECT * FROM goal_templates
        WHERE id = ${id}
        LIMIT 1
      `;
      return result[0] as GoalTemplate || null;
    } catch (error) {
      console.error('Error fetching goal template:', error);
      return null;
    }
  },
  
  async create(data: Omit<GoalTemplate, 'id' | 'created_at' | 'updated_at'>): Promise<GoalTemplate> {
    const result = await sql`
      INSERT INTO goal_templates (title, description, category, is_system, user_id)
      VALUES (${data.title}, ${data.description}, ${data.category}, ${data.is_system || false}, ${data.user_id})
      RETURNING *
    `;
    return result[0] as GoalTemplate;
  },
  
  async update(id: string, userId: string, data: Partial<GoalTemplate>): Promise<GoalTemplate> {
    const result = await sql`
      UPDATE goal_templates
      SET title = COALESCE(${data.title}, title),
          description = COALESCE(${data.description}, description),
          category = COALESCE(${data.category}, category),
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as GoalTemplate;
  },
  
  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM goal_templates
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count > 0;
  }
};

export type GoalTemplatesModule = typeof goalTemplatesModule;

export function registerGoalTemplates(db: { goalTemplates?: GoalTemplatesModule }) {
  db.goalTemplates = goalTemplatesModule;
}

export { goalTemplatesModule as goalTemplates };
